// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { createStructuredSelector } from "reselect";
import bindActions from "root/actions";
import {
	selectLocation,
	selectUploadContainerData,
	selectHasActiveUploads,
	selectShouldShowAdvancedOptions,
	selectAbortIds,
	selectRetryIds,
} from "../../selectors";
import UploaderContext from "./uploaderContext";
import createConnector from "./uploaderConnector";

// TODO: inspect whether 'containerData' should be broken apart (or custom memoization needed) to prevent unnecessary re-rendering
type Props = {
	location: { pathname: string },
	uploader: Object,
	children: Object,
	retryIds?: string[],
	abortIds?: string[],
	containerData: {
		uploadAdded?: { files: Object[], cropInfo: Object[] },
		queueIds: string[],
		closeCounter: number,
		widgetViewType: number,
		uploadOptions: {
			publicId?: string,
			tags?: string[],
			tagsInputValue: string,
			uploadPreset?: string,
		}
	},
	showAdvancedOptions: boolean,
	hasActiveUploads: boolean,
	[string]: Function
};

class UploadContainer extends Component<Props> {
	componentDidMount() {
		this.connector = createConnector(this.props, { history: this.props.history });
	}

	componentDidUpdate() {
		if (this.connector) {
			const { connector } = this; // flow is stupid! :(
			connector.processNextProps(this.props);
			connector.updateProps(this.props);
		}
	}

	connector = null;

	render() { // using Fragment because without it the app doesnt re-render on source change (route change) :(
		return <UploaderContext.Provider value={this.props.uploader}>
			<>
				{this.props.children}
			</>
		</UploaderContext.Provider>;
	}
}

export default withRouter<Props>(connect(
	createStructuredSelector({
		containerData: selectUploadContainerData,
		abortIds: selectAbortIds,
		retryIds: selectRetryIds,
		hasActiveUploads: selectHasActiveUploads,
		location: selectLocation,
		showAdvancedOptions: selectShouldShowAdvancedOptions,
	}),
	bindActions,
)(UploadContainer));
